export const SEARCH_PRODUCTS_WATCHER = 'SEARCH_PRODUCTS_WATCHER';
export const SEARCH_PRODUCTS_SUCCESS = 'SEARCH_PRODUCTS_SUCCESS';
export const SEARCH_PRODUCTS_FAILED = 'SEARCH_PRODUCTS_FAILED';
